import { render, staticRenderFns } from "./TwoFaVerification.vue?vue&type=template&id=396a0ada&scoped=true"
import script from "./TwoFaVerification.vue?vue&type=script&lang=js"
export * from "./TwoFaVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396a0ada",
  null
  
)

export default component.exports